<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="fetchData()" type="primary" class="btn-in-line" plain>show all triggers</zm-button>
            <zm-input size="small" placeholder="triggerId" v-model.trim="search" class="search-input" @keyup.enter.native="searchByName()">
                <zm-button size="small" slot="append" icon="zm-icon-search" @click="doSearch()"></zm-button>
            </zm-input>
        </zm-row>
        <div class="table-container">
            <zm-table resizable border :data="list" v-loading="loading">
                <zm-table-column prop="triggerId" label="triggerId" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <!-- <zm-table-column prop="triggerParam.topicId" label="topicId" align="center">
                </zm-table-column>
                <zm-table-column prop="triggerParam.status" label="status" align="center">
                </zm-table-column>
                <zm-table-column prop="triggerParam.name" label="name" align="center">
                </zm-table-column>
                <zm-table-column prop="triggerParam.keyword" label="keyword" align="center">
                </zm-table-column> -->
                <zm-table-column prop="triggerParam" label="triggerParam" align="center">
                    <template slot-scope="scope">
                        <zm-tooltip placement="right">
                            <div slot="content">
                                <p v-for="(value, index) in scope.row.triggerParam" :key="index">{{ index }}: {{ value }}</p>
                                <!-- <p>status: {{ scope.row.triggerParam.status }}</p>
                                <p v-if="scope.row.triggerParam.name">name: {{ scope.row.triggerParam.name }}</p>
                                <p v-if="scope.row.triggerParam.keyword">keyword: {{ scope.row.triggerParam.keyword }}</p> -->
                            </div>
                            <zm-tag size="medium" type="">show params</zm-tag>
                        </zm-tooltip>
                    </template>
                </zm-table-column>
                <zm-table-column prop="maxRetryTimes" label="maxRetryTimes" align="center">
                </zm-table-column>
                <zm-table-column prop="reachMaxFailed" label="reachMaxFailed" align="center">
                </zm-table-column>
                <zm-table-column prop="taskCount" label="taskCount" align="center">
                </zm-table-column>
                <zm-table-column prop="status" label="status" align="center">
                </zm-table-column>
                <zm-table-column prop="modifiedTime" label="modifiedTime" align="center" :formatter="setTime" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column label="operate" width="150px" align="center">
                    <template slot-scope="scope">
                        <zm-button size="small" class="btn-contain" type="icon" title="show tasks" icon="zm-icon-eyes" @click="showTasks(scope.row.triggerId)"></zm-button>
                        <!-- <zm-button size="small" class="btn-contain" type="icon" title="recovery trigger" icon="zm-icon-play-circle-outline" @click="recoveryTrigger(scope.row.id)" v-if="hasPermission"></zm-button> -->
                        <zm-button size="small" class="btn-contain" type="icon" title="delete trigger" icon="zm-icon-delete" @click="deleteTrigger(scope.row.id)" v-if="hasPermission"></zm-button>
                        <zm-dropdown class="btn-contain" style="margin-left: 10px;" @command="handleCommand" v-if="hasPermission">
                            <zm-button type="icon" icon="zm-icon-more" class="btn-contain"></zm-button>
                            <zm-dropdown-menu slot="dropdown">
                                <zm-dropdown-item :command="{command: 'recoveryTrigger', param: scope.row.id}">
                                    Recovery Batch Trigger
                                </zm-dropdown-item>
                                <zm-dropdown-item :command="{command: 'batchTrigger', param: scope.row}" v-if="scope.row.triggerParam.scrollTo">
                                    Re-trigger Batch Trigger
                                </zm-dropdown-item>
                            </zm-dropdown-menu>
                        </zm-dropdown>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @current-change="paginationChange"
                    @size-change="handleSizeChange"
                    :current-page.sync="pageable.page" :page-size="pageable.size"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="pageable.total">
                </zm-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import {
    batchTrigger,
    listBatchTrigger,
    deleteBatchTrigger,
    listBatchTriggerById,
    recoveryBatchTrigger
} from '../../api/trigger'
export default {
    name: 'trigger',
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            list: [],
            loading: false,
            search: '',
            listBy: 0,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            }
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.listBy = JSON.parse(localStorage.params).listBy
            this.search = JSON.parse(localStorage.params).search
            this.pageable.page = JSON.parse(localStorage.params).page
            this.pageable.size = JSON.parse(localStorage.params).size
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
        if (this.listBy) {
            this.doSearch()
        } else {
            this.fetchData()
        }
    },
    watch: {
        listBy () {
            this.setURL()
        },
        search () {
            this.setURL()
        },
        'pageable.page' () {
            this.setURL()
        },
        'pageable.size' () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { listBy, search } = this
            const { page, size } = this.pageable
            const data = { path: this.$route.path, listBy, search, page, size }
            localStorage.params = JSON.stringify(data)
        },
        fetchData () {
            this.loading = true
            this.listBy = 0
            listBatchTrigger(this.pageable.size, this.pageable.page - 1).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        doSearch () {
            this.pageable.page = 1
            this.searchByName()
        },
        searchByName () {
            if (this.search !== '') {
                this.loading = true
                this.listBy = 1
                listBatchTriggerById(this.search, this.pageable.size, this.pageable.page - 1).then(response => {
                    const { content, pageable: { page, size }, total } = response
                    this.list = content
                    this.pageable.total = total
                    this.pageable.page = page + 1
                    this.pageable.size = size
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.$message({
                    message: 'Please input trigger id!',
                    type: 'warning'
                })
            }
        },
        handleCommand (command) {
            if (command.command === 'recoveryTrigger') {
                this.recoveryTrigger(command.param)
            } else if (command.command === 'batchTrigger') {
                this.batchTrigger(command.param)
            }
        },
        batchTrigger (row) {
            this.$confirm('This will re-trigger the tasks. Continue?', 'Warning', {
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                const { name,
                    keyword,
                    group,
                    topicId,
                    taskType,
                    from,
                    to,
                    status,
                    scrollFrom,
                    scrollTo } = row.triggerParam
                const { maxRetryTimes } = row
                const triggerId = row.triggerId.splice(0, row.triggerId.lastIndexOf('_'))
                const data = { name, keyword, group, topicId, taskType, triggerId, maxRetryTimes, from, to, status, scrollFrom, scrollTo }
                batchTrigger(data).then(response => {
                    this.$message({
                        message: 'Batch trigger success!',
                        type: 'success'
                    })
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Re-trigger canceled'
                })
            })
        },
        recoveryTrigger (id) {
            this.$confirm('This will recovery the batch trigger. Continue?', 'Warning', {
                confirmButtonText: 'Recovery',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                recoveryBatchTrigger(id).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Recovery batch trigger success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Recovery canceled'
                })
            })
        },
        deleteTrigger (id) {
            this.$confirm('This will permanently delete the batch trigger. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteBatchTrigger(id).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Delete batch trigger success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        paginationChange () {
            if (this.listBy) {
                this.searchByName()
            } else {
                this.fetchData()
            }
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
        },
        showTasks (id) {
            this.$router.push('/dashboard/trigger/' + id)
        }
    }
}
</script>
<style scoped>
.btn-in-line{
    margin: 10px
}
.zm-input-group{
    width: 20%;
}
.search-input{
    float: right;
    margin: 10px;
}
</style>
